import ky from "ky";
import { keycloak } from "@/auth/keycloak.ts";
import { i18n } from "@lingui/core";
import { logError } from "@/sentry.ts";

export const api = ky.extend({
  timeout: 30000,
  hooks: {
    beforeRequest: [
      async (request) => {
        try {
          await keycloak.updateToken(30);
          request.headers.set("Authorization", `Bearer ${keycloak.token}`);
          request.headers.set("accept-language", i18n.locale);
        } catch (e: unknown) {
          logError(e);
          window.location.reload();
        }
      },
    ],
    beforeError: [
      (error) => {
        logError(error);
        return error;
      },
    ],
  },
});
